import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//i18n
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { fetchNotifications, markNotificationAsRead } from "../../slices/notifications/thunk";

const style = document.createElement('style');
style.textContent = `
  @keyframes linearProgress {
    0% {
      transform: translateX(-100%);
    }
    50% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
document.head.appendChild(style);

const NotificationDropdown = (props: any) => {
  const [menu, setMenu] = useState(false);
  const dispatch = useDispatch<any>();

  const selectNotifications = createSelector(
    (state: any) => state.Notifications,
    (notifs) => ({
      notifications: notifs.notifications,
      loading: notifs.loading,
    })
  );
  const { notifications, loading: showloader } = useSelector(selectNotifications);

  const handleNotificationClick = (notificationId: number, isRead: boolean) => {
    if (!isRead) {
      dispatch(markNotificationAsRead(notificationId));
    }
  };

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">
            {notifications.filter((n: any) => !n.is_read).length}
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          {/* Linear Loading Indicator */}
          {showloader && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: '#e9ecef',
              overflow: 'hidden',
              zIndex: 1000
            }}>
              <div style={{
                height: '100%',
                background: 'linear-gradient(90deg, #556ee6 0%, #3b5de7 50%, #556ee6 100%)',
                animation: 'linearProgress 1.5s ease-in-out infinite',
                transformOrigin: 'left center'
              }} />
            </div>
          )}
          
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <Link to="/notifications" className="small">
                  {" "}
                  View All
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {notifications.length === 0 ? (
              <div className="text-center text-muted py-4">{props.t("No notifications")}</div>
            ) : (
              notifications.map((notification: any, idx: number) => (
                <div 
                  key={idx}
                  className="text-reset notification-item"
                  onClick={() => handleNotificationClick(notification.id, notification.is_read)}
                  style={{ 
                    cursor: 'pointer', 
                    backgroundColor: notification.is_read ? 'transparent' : '#f8f9fa',
                    opacity: notification.is_read ? 0.7 : 1
                  }}
                >
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <i className="bx bx-bell" />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">
                        {notification.title}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {notification.message}
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                            {notification.created_at ? (
                            <span>
                              {(() => {
                              const now = new Date();
                              const created = new Date(notification.created_at);
                              const diff = Math.floor((now.getTime() - created.getTime()) / 1000);

                              if (diff < 60) return `${diff} seconds ago`;
                              if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
                              if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
                              return `${Math.floor(diff / 86400)} days ago`;
                              })()}
                            </span>
                            ) : null}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to="/notifications"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};


export default withTranslation()(NotificationDropdown);